import React, { useState, useEffect } from 'react';
import { ListIcon, Button, ActiveBadge } from './SkepticParts';



const PriceCard = ({tier, subs_levels, user_level, user_data, className = '', isAccountCard = false}) => {
    //TODO -> sublevels should be rather tier_name + price_combination to get really distinctive combination.
    const calc_card_level = subs_levels.indexOf(tier.name);
    const user_has_this_tier = user_level === calc_card_level;

    // console.log('[+] Tier -> ', tier);
    //console.log('[+] Subs_levels -> ', subs_levels);
    //console.log('[+] User_level -> ', user_level);
    //console.log('[+] User_data -> ', user_data);
    //console.log('[+] Card level -> ', calc_card_level);


    const determineIntent = () => {
        const user_curr_level = user_level;
        const intended_tier_level = calc_card_level;
        console.log('Current user level => ', user_curr_level);        
        console.log('Intended tier level => ', intended_tier_level);        

        //Match user want to resubscribe under same membership
        if(user_curr_level === intended_tier_level){
            console.log('You are already subscribed under this tier!');
            return 'tier_match';
        }        
        //Users intent to upgrade their subscription = first free member, first paid subscribe, upgrade of running subscription
        if(user_curr_level < intended_tier_level){
            if(user_data.member_status === true){
                console.log('Subscription Upgrade!');
                return('paid_upgrade');

            }else if(intended_tier_level == 1){
                console.log('Free membership event!');
                return 'free_member';

            }else{
                console.log('First paid subscription event!');
                return 'paid_member';
            }
        }
        //User intent to downgrade paid subscription or cancel running subscription
        if(user_curr_level > intended_tier_level){
            if(intended_tier_level == 1){
                console.log('You can cancel subscription account settings!');
                return('cancel_subscription');
            }
            else{
                console.log('Subscription Downgrade!');
                return('paid_downgrade');
            }
        }
    }

    const handleSubscription = () => {
        const intent = determineIntent();

        switch (intent) {
            case 'tier_match':
                alert('[+] You are already subscribed under this tier...');
                break;
            case 'paid_upgrade':
                //alert('[+] Upgrade of paid subscription...');
                window.dispatchEvent( new CustomEvent('openUpdatePaidMemberModal', { detail: { intention:intent, user_data: user_data, tier_data: tier }} ));
                break;
            case 'paid_downgrade':
                window.dispatchEvent( new CustomEvent('openNoiseAlert', { detail: {type: 'danger', title: 'Not Allowed', text: `Subscription downgrade is not allowed.` , duration: 5000}} ));
                //window.dispatchEvent( new CustomEvent('openUpdatePaidMemberModal', { detail: { intention:intent, user_data: user_data, tier_data: tier }} ));
                break;
            case 'free_member':
                //console.log('[+] User wants to register as free member...');
                window.dispatchEvent( new CustomEvent('alpinefreemembersubsmodal', { detail: { intention:intent, user_data: user_data, tier_data: tier }} ));
                break;
            case 'cancel_subscription':
                //This scenario should not happen in this part, we use handleUnsubscribe below for this!
                window.dispatchEvent( new CustomEvent('openNoiseAlert', { detail: {type: 'danger', title: 'Not Allowed', text: `You can cancel subscription in Account settings.` , duration: 5000}} ))
                break;
            case 'paid_member':
                //alert('[+] User wants to become a paid member, prepare checkout...');
                window.dispatchEvent( new CustomEvent('openBecomePaidMemberModal', { detail: { intention:intent, user_data: user_data, tier_data: tier }} ));
                break;
            default:
                console.error('[X] Unknown intent');
                throw new Error('Unknown intent');
        }
    };

    const handleUnsubscribe = () => {
        window.dispatchEvent( new CustomEvent('openCancelSubscriptionModal', { detail: { user_data: user_data, tier_data: tier } } ));
    }

    const calc_button_text = ()=>{
        if(user_level > 1){
            if(user_has_this_tier){
                if(isAccountCard) return 'Unsubscribe';
                return 'Current Plan';
            }else{
                return 'Upgrade';
            }
        }else{
            if(user_has_this_tier){
                return 'Current Plan';
            }else{
                return 'Subscribe';
            }            
        }
    }



    return(
        <article 
        className={`${calc_card_level <= user_level ? 
           'bg-skeptic-background  border border-black border-opacity-5 dark:bg-skeptic-background-dark dark:border-white dark:border-opacity-5'
         : 'bg-skeptic-gray border border-black border-opacity-5 dark:bg-skeptic-gray-dark dark:border-white dark:border-opacity-5'} ${className} flex w-full flex-col ${user_has_this_tier ? 'order-1' : 'order-2'} rounded-md pt-12 pb-14`}>
        
            <h3 className="text-center text_28 font-bold text-skeptic-charcoal dark:text-skeptic-foreground-dark px-5 tracking-[-0.56px]" aria-describedby="planDescription">{tier.name}</h3>

            {user_has_this_tier ? (<div className='flex justify-center mt-5'><ActiveBadge className={'justify-center'}/></div>) : null}
            
            <div className='mt-5 px-5 2xl:px-10'>
                <div className='flex gap-2 justify-center '>
                    <span className="block text_56_price_card leading-none pt-1 font-bold text-skeptic-charcoal dark:text-skeptic-foreground-dark">${
                    (()=>{
                        if(tier.type == 'paid'){
                           return tier.price / 100; 
                        }else{
                            return 0;
                        }            
                    })()}</span>
                    <span className="block leading-none self-end mb-1.5 text_28 text-[#6f6f6f]">/{tier.interval}</span>
                </div>
            </div>

            <div className='px-5 2xl:px-10 w-full mt-12'>
                <ul className="pl-6 list-inside space-y-2 text-base min-h-[200px] text-skeptic-charcoal dark:text-skeptic-foreground-dark">
                    {tier.benefits.map((benefit, index) => (
                        <li className='flex relative py-0.5' key={index}>
                            <ListIcon className="size-[1.125rem] absolute -left-6 top-[3px]"/>
                            {benefit}
                        </li>
                    ))}            
                </ul>
            </div>       

            <div className={`px-5 2xl:px-10 mt-5 w-full h-full flex flex-col justify-end ${calc_card_level < user_level ? 'invisible' : ''}`}>
            {
                calc_button_text() === 'Unsubscribe' ? (
                    <Button 
                    className={'w-full whitespace-nowrap justify-center'} 
                    text={calc_button_text()} 
                    state={'default'}
                    onClick={handleUnsubscribe}        
                    />

                ) : (
                    <Button 
                    className={'w-full whitespace-nowrap justify-center'} 
                    text={calc_button_text()} 
                    state={user_has_this_tier ? 'disabled' : 'default'}
                    onClick={user_has_this_tier ? null : handleSubscription}        
                    />
                )
            }

            




            </div>


        </article>
    )
}

export default PriceCard;